import { useQuery } from '@tanstack/react-query';

import { GetConnectedAccountsResponse } from '@/api/userAccount/types';
import { RequestOptions, axios } from '@/common/axios';
import { QueryConfig } from '@/common/react-query';

// dashboard calls these "ConnectedAccounts"
// wavefleet calls these "ExternalIntegrations"
export const getConnectedAccounts = async (options?: RequestOptions) => {
    const response = await axios.get<GetConnectedAccountsResponse, GetConnectedAccountsResponse>(
        `/account/integrations`,
        options
    );
    return response.data;
};

type UseConnectedAccountsOptions = {
    config?: QueryConfig<typeof getConnectedAccounts>;
};

export const useConnectedAccounts = ({ config = {} }: UseConnectedAccountsOptions = {}) => {
    return useQuery({
        ...config,
        queryKey: ['user-connected-accounts'],
        queryFn: ({ signal }) => getConnectedAccounts({ signal }),
        staleTime: 1000 * 60 * 30, // 30 minutes
    });
};
